module.exports = __webpack_public_path__ + "static/img/supplychain.9c026ab4.jpg";